import script from "./MainInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInput.vue?vue&type=script&setup=true&lang=js"

import "./MainInput.vue?vue&type=style&index=0&id=1d835c62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d835c62"]])

export default __exports__